import { connect } from 'react-redux';
import Login from './login';
import * as AC from '../../actions/actionCreators';

function mapStateToProps(state) {
	return {
		error: state.profile.error,
		isLoading: state.profile.isLoading,
		mfaRequired: state.profile.mfaRequired,
		mfaTicket: state.profile.mfaTicket,
		mfaUsername: state.profile.mfaUsername
	};
}

function mapDispatchToProps(dispatch) {
	return {
		login: (username, password) => dispatch(AC.ProfileLoginStarted(username, password)),
		verifyMfa: (ticket, code) => dispatch(AC.ProfileVerifyMfaStarted(ticket, code)),
		cancelMfa: () => dispatch(AC.ProfileMfaCancelled())
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);